import { GridApi } from 'ag-grid-community';
import EvidenceFieldActions from 'components/tables/data/evidence-field/EvidenceFieldActions';
import { EvidenceFieldRow } from 'components/tables/data/evidence-field/types';

/**
 * Column for the actions.
 */
export default function ActionsColumn({ api, data }: { api: GridApi<EvidenceFieldRow>; data: EvidenceFieldRow }) {
  return <EvidenceFieldActions {...data} compactOnTablet onDelete={() => api.applyTransaction({ remove: [data] })} />;
}
